<template>
  <BaseView class="index-container">
    <div slot="contantView" class="content">
      <div class="index-panel">
        <div class="nav-panel">
          <HeaderView :active-index="3" />
          <img src="../assets/spsc/whyUs/navBg.png" class="navImg"/>
        </div>
        <section class="nav-section">
          <div class="nav-info">
            <div class="nav-main-text" @click="goGoalPage('/')">Home</div>
            <div class="nav-arrow">></div>
            <div class="nav-sub-text" @click="goGoalPage('/whyUs')">Why Us</div>
          </div>
          <div class="nav-line"></div>
        </section>
        <section class="content-panel">
          <div class="left-info">
            <div class="team-pic"></div>
            <div class="work-pic"></div>
          </div>
          <div class="right-info">
            <div class="team-group">
              <div class="title-text">First-class Manageme Team</div>
              <div class="content-group">
                <span>Internationally experienced senior management team with over 50 years China Procurement and </span>
                <span>Project Delivery combined. The integration of the in-house local managers with the project team makes</span>
                <span>the decision making more streamlined and timely. Local team supported by expat supervisors to make</span>
                <span>sure the supplier management, quality, safety and delivery in line with international standard</span>
              
              </div>
            </div>
            <div class="network-group">
              <div class="title-text">Extensive Supply-chain Network</div>
              <div class="content-group">
                <span>Supplier network cultivated thru experience and relationships thru the years allow for a vast database</span>
                <span>of capable suppliers. Sino-Pacific Supply Chain Co., Ltd relies on large and medium-size joint venture</span>
                <span>manufacturing companies as its Major supplier resource, actively develop strategic partnerships. </span>
                <span>Simultaneously, develop small size local suppliers, and keep training them on ISO system and delivery</span>
                <span>capabilities</span>
              </div>  
            </div>
            <div class="system-group">
              <div class="title-text">Management & Quality System</div>
              <div class="content-group">
                <span>SPSC Self-developed Project Management System was applied in the project execution stage. With</span>
                <span>the support of SP-PMS system, ”just in time” action was built to monitor the project status, more</span>
                <span>effectively predict the risk and prepare preventive solutions in advance. That’s guiding a high quality</span>
                <span>performance and successful delivery of the project.</span>
              </div>
            </div>
          </div>
        </section>
        <FooterView />
      </div>
    </div>
  </BaseView>
</template>

<script>
import BaseView from '@/components/BaseView.vue'
import HeaderView from '@/components/HeaderView.vue'
import FooterView from '@/components/FooterView.vue'

export default {
  name: '',
  props: {

  },
  components: {
    BaseView,
    HeaderView,
    FooterView
  },
  data () {
    return {
      
      linkArrs: [{
        id: 1,
        text: 'HOME',
        linkUrl: '',
        subLink: [{
          id: '11',
          text: 'Home',
          linkUrl: '',
        }]
      }, {
        id: 2,
        text: 'CORE BUSINESS',
        linkUrl: '',
        subLink: [{
          id: '21',
          text: 'Project Procurement&Management',
          linkUrl: '',
        }, {
          id: '22',
          text: 'Supply-chain Management',
          linkUrl: '',
        }, {
          id: '23',
          text: 'Commodity trading',
          linkUrl: '',
        }]
      }, {
        id: 3,
        text: 'SERVICE&PROJECTS',
        linkUrl: '',
        subLink: [{
          id: '31',
          text: 'Service&Projects',
          linkUrl: '',
        }]
      }, {
        id: 4,
        text: 'WHY US',
        linkUrl: '',
        subLink: [{
          id: '41',
          text: 'Why us',
          linkUrl: '',
        }]
      }, {
        id: 5,
        text: 'CAPABILITIES',
        linkUrl: '',
        subLink: [{
          id: '51',
          text: 'Capabilities',
          linkUrl: '',
        }]
      }, {
        id: 6,
        text: 'HSE',
        linkUrl: '',
        subLink: [{
          id: '61',
          text: 'Capabilities',
          linkUrl: '',
        }]
      }, {
        id: 7,
        text: 'CONTACT US',
        linkUrl: '',
        subLink: [{
          id: '71',
          text: 'Capabilities',
          linkUrl: '',
        }]
      }]
    }
  },
  methods: {
    goGoalPage( pathName) {
      this.$router.replace({ path: pathName})
    }

  },
  created () {
  }
}
</script>
<style scoped lang="scss">

.index-container {
  background: #FFFFFF;
  width: 100%;
}
.index-panel {
  width: 100%;
  min-width: 1200px;
} 

.nav-panel {
  width: 100%;
  height: 100%;
}

.navImg {
  width: 100%;
  height: auto;
  margin-top: -80px;
}

.nav-section {
  width: 1200px;
  margin: 40px auto 60px auto;
}

.nav-info {
  display: flex;
  justify-content: flex-start;
  justify-items: center;
}

.nav-main-text, .nav-sub-text {
  font-size: 14px;
  color: #333333;
  cursor: pointer;
}

.nav-arrow {
  margin: 0 10px;
}

.nav-line {
  width: 100%;
  height: 1px;
  background: #D8D8D8;
  margin-top: 16px;
}

.content-panel {
  width: 1200px;
  margin: 0 auto 100px auto;
  display: flex;
}

.left-info {
  width: 410px;
}

.team-pic {
  width: 410px;
  height: 315px;
  background: url('../assets/spsc/whyUs/team-pic.png') no-repeat;
  background-size: contain;
  margin-bottom: 24px;
}

.work-pic {
  width: 410px;
  height: 315px;
  background: url('../assets/spsc/whyUs/work-pic.png') no-repeat;
  background-size: contain;
}

.right-info {
  width: 730px;
  margin-left: 60px;
}

.team-group {
  margin: 10px 0 60px 0;
}

.network-group {
  margin: 0 0 60px 0;
}

.title-text {
  font-size: 24px;
  font-weight: bold;
  color: #111111;
  margin-bottom: 20px;
}

.content-group {
  font-size: 16px;
  color: #333333;
  line-height: 28px;
}

span {
  white-space: nowrap;
}
</style>